// src/pages/Summary.js
import React, { useContext, useState, useEffect } from "react";
import {
  Button, Typography, Divider, List, ListItem, ListItemText,
  Box, Card, CardContent, IconButton, Link, Drawer, useMediaQuery,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  eliminarItemCarrito,
  obtenerDetalleCarrito,
  obtenerMuestroCarrito,
  dobleChequeoDisponibilidad,
} from "../../services/motorService";
import RoomTypeRatePlanContext from "../contexts/RoomTypeRatePlanContext";
import RoomsContext from "../contexts/RoomsContext";
import useSession from "../../services/session";
import DialogRateDetail from "./DialogRateDetail";
import Cookies from "js-cookie";
import CheckoutContext from "../contexts/CheckoutContext";

const Summary = () => {
  const BASE_URL = "/MotorReservasAdmintour";
  const { cartItems, setCartItems } = useContext(RoomTypeRatePlanContext);
  const { rooms, setRooms, groupSlotMap, unbindGroup } = useContext(RoomsContext);
  const { setFormValues } = useContext(CheckoutContext);

  const [open, setOpen] = useState(false);
  const [rateDetail, setRateDetail] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [detalleCarrito, setDetalleCarrito] = useState({});

  const isMobileOrTablet = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;
  const sesion = useSession();

  const emptyValues = {
    motorreservanombretitular: "",
    motorreservaapellidotitular: "",
    reservanombre: "",
    reservatipodocumento: "",
    reservadocumento: "",
    reservatelefono: "",
    correoElectronico: "",
    reservadireccion: "",
    reservafechanacimiento: null,
    reservapais: "",
    reservaobservaciones: "",
    reservaautocolor: "",
    reservaautomarca: "",
    reservaautomatricula: "",
  };

  const handleConfirm = async () => {
    // ✅ cartItems ya es el array plano (antes era cartItems.cartNoPrice).
    const carrito = Array.isArray(cartItems) ? cartItems : [];
    if (carrito.length === 0) return;

    // 1) Agrupar por {desde, hasta, tipo}
    const grupos = new Map();
    for (const it of carrito) {
      console.log("carrito item:", it);
      const desde = it?.CarritoItemDesde;
      const hasta = it?.CarritoItemHasta;
      const tipo = it?.CarritoItemCodTipHab;
      const nombreTipo = it?.CarritoItemTipoHab;
      if (!desde || !hasta || !tipo || !nombreTipo) continue;

      const key = `${desde}__${hasta}__${tipo}__${nombreTipo}`;
      const prev = grupos.get(key);
      grupos.set(key, prev ? { ...prev, cantidad: prev.cantidad + 1 }
        : { desde, hasta, tipo, nombreTipo, cantidad: 1 });
    }

    // 2) Consultar una vez por grupo (secuencial para no saturar la API)
    const problemas = [];
    for (const g of grupos.values()) {
      try {
        console.log("codigo hotel:", hotCod);
        console.log("desde:", g.desde);
        console.log("hasta:", g.hasta);
        console.log("tipohab:", g);
        const resp = await dobleChequeoDisponibilidad(
          hotCod,      // hotcod
          g.desde,     // DesdeFecha
          g.hasta,     // HastaFecha
          g.tipo       // BuscoTipoHab
        );
        console.log("Respuesta doble chequeo", resp);

        // 3) Tomar "quedan" sin importar si viene plano o en array unitario
        const quedan =
          resp?.data.TiposHabitacion[0].TipoHabQuedan ?? 0;

        if (Number(quedan) < Number(g.cantidad)) {
          problemas.push({
            grupo: g,
            motivo: `Solicitado ${g.cantidad}, disponibles ${quedan}`
          });
        }
      } catch (err) {
        problemas.push({ grupo: g, motivo: "Error consultando disponibilidad" });
      }
    }

    if (problemas.length > 0) {
      const msg = problemas
        .map(p => `• ${p.grupo.nombreTipo} (${p.grupo.desde}→${p.grupo.hasta}): ${p.motivo}`)
        .join("\n");
      alert(`Algunas habitaciones ya no tienen disponibilidad:\n\n${msg}`);
      return; // NO navegamos
    }

    // OK: continuar al checkout
    setFormValues(emptyValues);
    //navigate(`${BASE_URL}/checkout?hotcod=${hotCod}`);
    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", String(hotCod));

    navigate(`${BASE_URL}/checkout?${qs.toString()}`);
  };


  // Helpers
  const getGroupId = (item) => {
    const h = item?.habitacioncarrito;
    if (typeof h === "number" && h > 0) return h;
    return item?.CarritoItemLinea;
  };
  const sameStay = (a, b) =>
    a?.CarritoItemDesde === b?.CarritoItemDesde &&
    a?.CarritoItemHasta === b?.CarritoItemHasta;

  const fetchCart = async () => {
    try {
      const cart = await obtenerMuestroCarrito(hotCod, sesion);

      // Detalles para el Drawer (opcional)
      const detalles =
        cart && cart.length > 0
          ? await Promise.all(
            cart.map(async (item) => {
              const detalle = await obtenerDetalleCarrito(
                hotCod, sesion, item.CarritoItemLinea
              );
              return { linea: item.CarritoItemLinea, detalle };
            })
          )
          : [];
      const detallesAgrupados = detalles.reduce((acc, curr) => {
        acc[curr.linea] = curr.detalle;
        return acc;
      }, {});
      setDetalleCarrito(detallesAgrupados);

      // ✅ cartItems pasa a ser directamente el array (antes era
      // { cartNoPrice, price }). El total ya no se guarda acá: se recalcula
      // más abajo con `totalImporte` a partir del propio cartItems.
      setCartItems(cart || []);

      // ================== RECONSTRUCCIÓN ESTABLE POR MAPEOS ==================
      // 1) Pax por groupId (agregado robusto: máximo por campo)
      const paxByGroup = {};
      for (const it of cart || []) {
        const gid = String(getGroupId(it));
        const ad = parseInt(it?.CarritoItemMayores, 10) || 0;
        const ch = parseInt(it?.CarritoItemMenores, 10) || 0;
        if (!paxByGroup[gid]) paxByGroup[gid] = { adults: ad, children: ch };
        else {
          paxByGroup[gid].adults = Math.max(paxByGroup[gid].adults, ad);
          paxByGroup[gid].children = Math.max(paxByGroup[gid].children, ch);
        }
      }

      const prev = Array.isArray(rooms) ? rooms : [];
      const next = prev.map((slot) => {
        // Buscar si este slot tiene un groupId asignado
        const gid = Object.entries(groupSlotMap).find(([, rn]) => rn === slot.roomNumber)?.[0];
        if (gid && paxByGroup[gid]) {
          // Slot ocupado por ese groupId -> set pax del carrito y marcar inCart
          return {
            ...slot,
            adultsCount: paxByGroup[gid].adults,
            childrenCount: paxByGroup[gid].children,
            isInCart: true,
          };
        }
        // Slot sin groupId (o group ya no en carrito): que quede libre y
        // CONSERVAR sus pax anteriores (no cambiar adults/children)
        return { ...slot, isInCart: false };
      });

      setRooms(next);
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  };

  useEffect(() => {
    fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Borrado robusto: elimina el grupo tocado y desbindea
  const handleDeleteItem = async (itemOrLineNumber) => {
    try {
      const current = Array.isArray(cartItems) ? cartItems : [];
      const baseItem =
        typeof itemOrLineNumber === "object"
          ? itemOrLineNumber
          : current.find((i) => i.CarritoItemLinea === itemOrLineNumber);
      if (!baseItem) return;

      const groupId = getGroupId(baseItem);

      // Borrar hijas primero, base al final (misma estadía)
      const linesToDelete = current
        .filter(
          (i) =>
            sameStay(i, baseItem) &&
            (i.CarritoItemLinea === groupId || i.habitacioncarrito === groupId)
        )
        .sort((a, b) => {
          const aIsBase = a.CarritoItemLinea === groupId;
          const bIsBase = b.CarritoItemLinea === groupId;
          if (aIsBase && !bIsBase) return 1;
          if (!aIsBase && bIsBase) return -1;
          return 0;
        });

      for (const it of linesToDelete) {
        try {
          await eliminarItemCarrito(hotCod, sesion, it.CarritoItemLinea);
        } catch (err) {
          console.error("Error eliminando línea", it.CarritoItemLinea, err);
        }
      }

      // Desvincular ese groupId del slot
      unbindGroup(groupId);

      // Re-sync estable
      await fetchCart();
    } catch (error) {
      console.error("Error al eliminar ítems del carrito:", error);
    }
  };

  const handleChartDetail = async (lineNumber, ad, me) => {
    try {
      const detail = await obtenerDetalleCarrito(hotCod, sesion, lineNumber);
      setRateDetail(detail);
      setOpen(true);
    } catch (error) {
      console.error("Error al obtener el detalle del carrito:", error);
    }
  };

  const handleClose = () => setOpen(false);
  const toggleDrawer = (open) => () => setOpenDrawer(open);

  // ✅ cartItems ya es el array (antes: cartItems.cartNoPrice)
  const totalImporte = Array.isArray(cartItems)
    ? cartItems.reduce(
      (total, item) => total + parseFloat(item.CarritoItemTotal || 0), 0
    )
    : 0;

  const formatTitleDate = () => {
    if (Array.isArray(cartItems) && cartItems.length > 0) {
      const checkinDate = new Date(cartItems[0].CarritoItemDesde);
      const checkoutDate = new Date(cartItems[0].CarritoItemHasta);
      const d = (dt) => `${dt.getUTCDate()}/${dt.getUTCMonth() + 1}/${dt.getUTCFullYear()}`;
      return `Reserva del ${d(checkinDate)} al ${d(checkoutDate)}`;
    }
    return "";
  };

  const obtengoCarritoMoneda = (carrito) =>
    carrito && carrito.length > 0 ? carrito[0].CarritoItemMoneda : "";

  const drawerContent = (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>Resumen</Typography>
        {Array.isArray(cartItems) && cartItems.length > 0 ? (
          <>
            <Typography variant="body2" color="textSecondary">
              {formatTitleDate()}{" "}
              {`/ ${Math.round(
                (new Date(cartItems[0].CarritoItemHasta) -
                  new Date(cartItems[0].CarritoItemDesde)) /
                (1000 * 60 * 60 * 24)
              )} noche(s)`}
            </Typography>
            <Divider />
            <List>
              {cartItems.map((item, index) => (
                <div key={item.CarritoItemLinea}>
                  <ListItem alignItems="flex-start">
                    <ListItemText
                      primary={
                        <>
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                            {item.CarritoItemTipoHab}
                          </Typography>
                          <Typography variant="body1">{item.CarritoItemTarifa}</Typography>
                          <Link
                            href="#"
                            variant="body2"
                            color="#007289"
                            onClick={() => handleChartDetail(item.CarritoItemLinea)}
                          >
                            Detalle de la tarifa
                          </Link>
                        </>
                      }
                      secondary={
                        <>
                          <Typography component="div" color="textSecondary" sx={{ mt: 2 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography variant="body2" color="textSecondary">
                                {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {`${item.CarritoItemMoneda} ${parseFloat(
                                  item.CarritoItemTotal
                                ).toLocaleString("es-ES", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}
                              </Typography>
                            </Box>
                          </Typography>
                        </>
                      }
                    />
                    <IconButton edge="end" color="inherit" onClick={() => handleDeleteItem(item)}>
                      <DeleteIcon />
                    </IconButton>
                  </ListItem>
                  {index < cartItems.length - 1 && <Divider />}
                </div>
              ))}
              <Divider />
              <Typography component="div" sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>Total</Typography>
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {obtengoCarritoMoneda(cartItems)}{" "}
                    {parseFloat(totalImporte).toLocaleString("es-ES", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
              </Typography>
            </List>
          </>
        ) : (
          <Typography variant="subtitle1" color="textSecondary">
            No hay elementos en el carrito.
          </Typography>
        )}
      </CardContent>
      <CardContent>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            sx={{ width: "100%" }}
            disabled={!Array.isArray(cartItems) || cartItems.length === 0}
          >
            Continuar
          </Button>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <div>
      {isMobileOrTablet ? (
        <>
          <Drawer
            anchor="bottom"
            open={openDrawer}
            onClose={toggleDrawer(false)}
            sx={{ "& .MuiDrawer-paper": { padding: 2 } }}
          >
            {drawerContent}
          </Drawer>
          <Box
            sx={{
              position: "fixed", bottom: 0, left: 0, right: 0,
              backgroundColor: "white", zIndex: 10,
              boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)", padding: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <IconButton onClick={toggleDrawer(true)} sx={{ p: 0 }}>
                <ExpandLessIcon />
              </IconButton>
              <Typography variant="h6" sx={{ ml: 1 }}>
                {obtengoCarritoMoneda(cartItems)}{" "}
                {parseFloat(totalImporte).toLocaleString("es-ES", {
                  minimumFractionDigits: 2, maximumFractionDigits: 2,
                })}
              </Typography>
              <Button
                variant="contained" color="primary" onClick={handleConfirm} sx={{ ml: "auto" }}
                disabled={!Array.isArray(cartItems) || cartItems.length === 0}
              >
                Continuar
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        drawerContent
      )}

      <DialogRateDetail open={open} handleClose={handleClose} rateDetail={rateDetail} />
    </div>
  );
};

export default Summary;